import {useTranslation} from 'react-i18next'

const NoData = ({Colspan}) => {
  const {t} = useTranslation()

  return (
    <tr>
      <td colSpan={Colspan}>
        <p className='fs-4 text-danger text-center message-color'>
          {t('GLOBAL.DATA_NOT_AVAILABLE')}
        </p>
      </td>
    </tr>
  )
}

export default NoData
